import React from 'react';

import { useReactTable } from 'components/ReactTable';
import { UiKit } from 'components';

export default function TableClearFiltersButton({
  className = '',
  children = 'Clear All Filters'
}) {
  const {
    checkIfRefined,
    clearAllRefinements = () => {},
    searchState: { isFetchingFacets }
  } = useReactTable();

  const isFilterActive = checkIfRefined();
  const isButtonDisabled = !isFilterActive || isFetchingFacets;

  return (
    <UiKit.Button
      variant="outline"
      onClick={clearAllRefinements}
      disabled={isButtonDisabled}
      className={className}
    >
      {children}
    </UiKit.Button>
  );
}
